import { useStore } from "@tanstack/react-store";
import { useNavigate, useParams } from "react-router-dom";
import { usePermissions } from "../../../hooks/usePermissions";
import { useSpacePath } from "../../../hooks/useSpacePath";
import { navigationStore } from "../../../store/navigationStore";
import useGetProviderById from "../api/useGetProviderById";
import { useUpdateProviderTags } from "../api/useUpdateProviderTags";
import { ProviderTag } from "../types";

const MAPS_SEARCH_URL = 'https://www.google.com/maps/search/?api=1&query=';

export function getMapsUrl(address: string) {
  return `${MAPS_SEARCH_URL}${encodeURIComponent(address)}`;
}

export function useProviderPage() {
  const { isAdmin } = usePermissions();
  const { providerId } = useParams();
  const navigate = useNavigate();
  const spacePath = useSpacePath();
  const lastUrl = useStore(navigationStore, (state) => state.lastUrl);

  const { data: provider, isLoading } = useGetProviderById(providerId);
  const updateProviderTags = useUpdateProviderTags();

  const address = provider?.address?.trim() || null;

  function handleDeletionSuccess() {
    navigate(spacePath('/providers'));
  }

  function handleTagsChange(newTags: ProviderTag[]) {
    if (!provider?.id) return;
    updateProviderTags.mutate({
      providerId: provider.id,
      tagIds: newTags.map((t) => t.id),
    });
  }

  return {
    isAdmin,
    provider,
    isLoading,
    address,
    mapsUrl: address ? getMapsUrl(address) : null,
    backLink: lastUrl ?? spacePath('/providers'),
    handleDeletionSuccess,
    handleTagsChange,
  };
}
